import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-170552f3"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", {
    class: "consultation-button__icon",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M4.5 7A2.5 2.5 0 0 1 7 4.5h10A2.5 2.5 0 0 1 19.5 7v10A2.5 2.5 0 0 1 17 19.5H7A2.5 2.5 0 0 1 4.5 17V7Z",
            stroke: "currentColor",
            "stroke-width": "1.5"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "m5 7 7 5 7-5",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    ])
], -1));
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "consultation-button__copy" }, [
    /*#__PURE__*/ _createElementVNode("small", null, "¿Tenés una duda?"),
    /*#__PURE__*/ _createElementVNode("strong", null, [
        /*#__PURE__*/ _createElementVNode("span", { class: "desktop-label" }, "Hacer una consulta"),
        /*#__PURE__*/ _createElementVNode("span", { class: "mobile-label" }, "Consultar")
    ])
], -1));
const _hoisted_3 = [
    _hoisted_1,
    _hoisted_2
];
import { onMounted, onUnmounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConsultationFab',
    setup(__props) {
        const visible = ref(true);
        const scrollToContact = () => {
            document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        const handleViewportChange = () => {
            const contact = document.getElementById('contact-form');
            visible.value = !contact || contact.getBoundingClientRect().top > window.innerHeight * 0.72;
        };
        onMounted(() => {
            window.addEventListener('scroll', handleViewportChange, { passive: true });
            window.addEventListener('resize', handleViewportChange, { passive: true });
            handleViewportChange();
        });
        onUnmounted(() => {
            window.removeEventListener('scroll', handleViewportChange);
            window.removeEventListener('resize', handleViewportChange);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "consultation-fab" }, {
                default: _withCtx(() => [
                    _withDirectives(_createElementVNode("button", {
                        type: "button",
                        class: "consultation-button",
                        "aria-label": "Ir al formulario de consulta",
                        "aria-controls": "contact-form",
                        onClick: scrollToContact
                    }, _hoisted_3, 512), [
                        [_vShow, visible.value]
                    ])
                ]),
                _: 1
            }));
        };
    }
});
